import { Entity } from '../common-models/Entity';
import { Frame } from './Frame';

export class MultifocalInfo extends Entity {
    frameId?: number|null;
    frame: Frame;

    addField: string;

    actualBridge?: number|null;
    actualEyeWidth?: number|null;
    actualEyeHeight?: number|null;
    actualLargestDiagonal?: number|null;
}